import xss from 'xss'

export default defineNuxtPlugin((nuxtApp) => {
  const danishDictionary = {
    soccer: 'fodbold',
    single: 'enkelt',
    double: 'dobbelt',
    twin: 'tvilling',
    family: 'familie',
    paid: 'betalt',
    pending: 'afventer',
    failed: 'mislykkedes',
    close: 'annuller',
    participant: 'deltager',
    participants: 'deltagere',
    'match ticket': 'Kampbillet',
    flights: 'fly',
    flight: 'fly',
    hotel: 'hotel',
    ticket: 'billet',
    outwardflight: 'udrejse fly',
    returnflight: 'hjemrejse fly',
    requested_coupon_not_found: 'Koden er ikke gyldig'
  }

  const pluralizeDictionary = {
    // Single Form : [ 'Single Form', 'Plural Form']
    barn: ['barn', 'børn'],
    voksen: ['voksen', 'voksne'],
    person: ['person', 'personer'],
    kampbillet: ['kampbillet', 'kampbilletter'],
    stop: ['stop', 'stops']
  }

  const filters = {
    simpleFormatPrice (price, perPerson = 1) {
      return Math.round(parseFloat(price) / perPerson)
    },

    formatPrice (price, perPerson = 1) {
      const roundedValue = Math.abs(Math.round(parseFloat(price) / perPerson))

      const formatted = Intl.NumberFormat(
        nuxtApp.$i18n.localeProperties.value.iso,
        {
          minimumFractionDigits: 0
        }
      ).format(roundedValue)

      switch (nuxtApp.$i18n.localeProperties.value.currency) {
        case 'DKK':
          return `Kr. ${formatted},-`
        case 'NOK':
          return `kr ${formatted},-`
        default:
          return `${formatted} kr`
      }
    },

    formatPriceWithSign (value, perPerson = 1) {
      // Round Value
      const roundedValue = Math.round(parseFloat(value) / perPerson)
      const formattedPrice = this.formatPrice(roundedValue)

      let sign = ''
      if (roundedValue > 0) {
        sign = '+'
      }
      if (roundedValue < 0) {
        sign = '-'
      }

      return `${sign} ${formattedPrice}`
    },

    danishize (value) {
      return danishDictionary[value.toLowerCase()] || value
    },

    pluralize (value, number = 1) {
      if (!pluralizeDictionary[value]) {
        console.warn(`The plural form of ${value} was not defined`)

        return value
      }
      const index = number > 1 ? 1 : 0

      return pluralizeDictionary[value.toLowerCase()][index]
    },

    sanitizeHtml (value) {
      const whiteList = xss.getDefaultWhiteList()
      whiteList.a = [...whiteList.a, 'class', 'data-popup-page']

      return xss(value, {
        whiteList
      })
    }
  }

  return {
    provide: {
      filters
    }
  }
})
